import React from 'react'
import InstructorNavbar from '../components/instructor/InstructorNavbar'
import AddQuiz from '../components/quiz/AddQuiz'

const AddQuizPage = () => {
  return (
    <>
    <InstructorNavbar/>
    <AddQuiz/>
    </>
  )
}

export default AddQuizPage